import { render, staticRenderFns } from "./CustomerSelectInput.vue?vue&type=template&id=167b77b7&scoped=true&lang=pug&"
import script from "./CustomerSelectInput.vue?vue&type=script&lang=js&"
export * from "./CustomerSelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b77b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167b77b7')) {
      api.createRecord('167b77b7', component.options)
    } else {
      api.reload('167b77b7', component.options)
    }
    module.hot.accept("./CustomerSelectInput.vue?vue&type=template&id=167b77b7&scoped=true&lang=pug&", function () {
      api.rerender('167b77b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/forms/CustomerSelectInput.vue"
export default component.exports